import React from "react";

/**
 * Verified-creator badge — a small red checkmark in a filled rosette.
 * Use inline next to a name. Size driven by parent font-size or `size` prop.
 */
export default function VerifiedBadge({ size = 14, title = "Verified creator", className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center align-[-2px] shrink-0 ${className}`}
      title={title}
      aria-label={title}
      data-testid="verified-badge"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 1.5l2.4 1.7 2.9-.5 1.4 2.6 2.6 1.4-.5 2.9L22.5 12l-1.7 2.4.5 2.9-2.6 1.4-1.4 2.6-2.9-.5L12 22.5l-2.4-1.7-2.9.5-1.4-2.6-2.6-1.4.5-2.9L1.5 12l1.7-2.4-.5-2.9 2.6-1.4 1.4-2.6 2.9.5L12 1.5z"
          fill="#FF3B30"
        />
        <path
          d="M7.5 12.5l3 3 6-6.5"
          stroke="#fff"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
